<template>
  <div class="wrapper add-knowledge">
    <b-modal
      id="modal"
      v-model="isOpen"
      header-bg-variant="light"
      footer-bg-variant="light"
      :title="$t('pages.user-cv.text-cv.modal.title', 'Edit CV in text')"
      :ok-title="$t('generic.save', 'Save')"
      :cancel-title="$t('generic.cancel', 'Cancel')"
      @hidden="$emit('closeModal')"
      @ok="handleOk"
      @show="load()"
    >
      <label for="speakSelect">{{ $t('pages.user-cv.text-cv.modal.text', 'CV in text') }}</label>
      <b-form-textarea
        id="textarea"
        v-model="text_cv"
        :placeholder="$t('pages.user-cv.text-cv.modal.text.placeholder', 'Write your text here')"
        rows="9"
        max-rows="9"
        :state="text_cv.length <= 1000"
      />
      <div class="grey">
        {{
          $t(
            'generic.char-counter',
            '{current}/{max} characters',
            {
              current: textLength,
              max: 200
            }
          )
        }}
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    textCv: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      text_cv: ""
    }
  },
  computed: {
    textLength() {
      return this.text_cv.length;
    }
  },
  methods: {
     handleOk() {
      this.axios.put('/cv/update/text_cv', { text_cv: this.text_cv })
        .then(response => {
          this.$emit('updateCv', response.data);
          this.$emit('closeModal');
          this.$toastNotification('success', '', this.$t('pages.user-cv.profile-update.success', 'Profile updated successfully!'))
        })
        .catch( () => {
          this.$toastSomethingWentWrong();
        });
    },
    load() {
      if(this.textCv) {
        this.text_cv = this.textCv;
      }
    }
  }
}
</script>

<style lang="scss">
  .add-knowledge {
    font-size: 0.9rem;
  }
</style>
